import BaseApi from './baseApi';
import ICompany from '../models/ICompany';
import IAuthentication from '../models/IAuthentication';
import { EMPTY_GUID } from '../../config/constants';
export default class CompanyApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Companies");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCompaniesById(idCompany: string) : Promise<ICompany[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var company: ICompany[] = [];
            company = response.data as ICompany[];
            return company;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetNextCode(idCompany: string, element: string) : Promise<number> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadNextInboundCode(idCompany, element);
        }
        
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return -1;
        if (response.isSuccess) {
            var code: number;
            code = response.data as number;
            return code;
        } else {
            this.modelState = response.errorState;
            return -1;
        }
    }

    async GetCompanies() : Promise<ICompany[]> {
        let json : string = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var company: ICompany[] = [];
            company = response.data as ICompany[];
            return company;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCompany(company: ICompany) : Promise<string> {
        const json = this.getJsonSave(company);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCompany(company: ICompany) : Promise<boolean> {
        const json = this.getJsonUpdate(company);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCompany(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Companies",
            "conditions": [{
                "Item1": "Companies",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(company: ICompany) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": company.name
            }, {
                "Item1": "fiscalIdentifier",
                "Item2": company.fiscalIdentifier
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": company.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": company.phoneNumber
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Companies"
        };
        return json;
    }

    private getJsonUpdate(company: ICompany) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": company.name
            }, {
                "Item1": "fiscalIdentifier",
                "Item2": company.fiscalIdentifier
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": company.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": company.phoneNumber
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Companies",
            "keyvalue": company.id
        };
        return json;
    }

    private getJsonReadNextInboundCode(idCompany: string, element: string) : any {
        const json = {
            "spname": "dbo.GetNumerator",
            "parameters": [{
                "Item1": "IdCompany ",
                "Item2": idCompany
            }, {
                "Item1": "Element",
                "Item2": element
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Companies",
                "Item2": "id"
            }, {
                "Item1": "Companies",
                "Item2": "name"
            }, {
                "Item1": "Companies",
                "Item2": "fiscalIdentifier"
            }, {
                "Item1": "Companies",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "Companies",
                "Item2": "phoneNumber"
            }],
            "tables": [{
                "Item1": "Companies"
            }, {
                "Item1": "ListPhonePrefixes"
            }],
            "joins": [{
                "Item1": "Companies",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Companies",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "Companies.name"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Companies",
                "Item2": "id"
            }, {
                "Item1": "Companies",
                "Item2": "name"
            }, {
                "Item1": "Companies",
                "Item2": "fiscalIdentifier"
            }, {
                "Item1": "Companies",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "Companies",
                "Item2": "phoneNumber"
            }],
            "tables": [{
                "Item1": "Companies"
            }, {
                "Item1": "ListPhonePrefixes"
            }],
            "joins": [{
                "Item1": "Companies",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Companies",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Companies",
                "Item2": "id",
                "Item3": "=",
                "Item4": idCompany
            }],
            "orderBy": [{
                "Item1": "Companies.name"
            }]
        };
        return json;
    }
}
